module.exports = __webpack_public_path__ + "static/media/Why-charter-with.faf93a13.jpg";